import SegmentRule from '@/engine/rules/segment-rule'
import GameState from '@/engine/models/game-state'
import TurnState from '@/engine/models/turn-state'
import Segment from '@/engine/models/segment'
import States from '@/engine/common/states'
import audioService from '@/services/audio-service'
import bbe from '@/engine/components/handle-bbe'

export default class BullForLandBullRentRule extends SegmentRule {

    protected segmentSatisfied(turnState: TurnState, state: GameState, segment: Segment): boolean {
        return state.shot === 'b00'
            && state.gameplay.enabledBullForLand === true
    }

    protected segmentAction(turnState: TurnState, state: GameState, segment: Segment): GameState {
        if (States.allCountriesConquered(state)) {
            bbe(turnState, state, segment)
        } else if (state.gameplay.enabledBull) {
            bbe(turnState, state, segment)
        } else if (state.hasHit('e00') || state.hasHit('b00')) {
            States.pay(state, segment)
            if (turnState.turnComplete === false) {
                audioService.playPayRent()
            }
        }
        return state
    }
}
